import * as i from 'types';
import styled, { css } from 'styled-components';

import { media } from 'styles/utils';

export const CheckboxContainer = styled.div<CheckboxContainerProps>`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  width: 100%;
  font-size: 12px;
  line-height: 150%;
  border: 1px solid transparent;
  border-radius: ${({ theme }) => theme.ui.borderRadius.badge};
  box-shadow: ${({ theme }) => theme.ui.shadows};
  padding: 12px 24px;
  
  &:last-of-type {
    margin-bottom: 0;
  }

  ${({ direction }) => direction === 'horizontal' && media.tablet`
    width: auto;
    margin: 0 24px 0 0;

    &:last-of-type {
      margin: 0;
    }
  `}

  ${({ isActive }) => isActive && css`
    border: 1px solid ${({ theme }) => theme.colors.primary};
  `}
`;

type CheckboxContainerProps = Pick<i.FormFieldProps, 'direction'> & { isActive?: boolean };

export const Container = styled.div<ContainerProps>`
  height: 24px;
  width: 24px;
  margin-right: 8px;
  border: 1px solid ${({ theme }) => theme.colors.gray.border};
  flex-shrink: 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ isRadio }) => css`
    border-radius: ${isRadio ? '100%' : '4px'};
  `}

  ${({ isActive }) => isActive && css`
    background-color: ${({ theme }) => theme.colors.primary};
    border: 1px solid ${({ theme }) => theme.colors.primary};
  `}
`;

type ContainerProps = {
  isActive?: boolean;
  isRadio?: boolean;
};

export const Circle = styled.div`
  height: 6px;
  width: 6px;
  border-radius: 100%;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const Check = styled.div`
  display: inline-block;
  transform: rotate(45deg);
  height: 12px;
  width: 6px;
  margin-top: -2px;
  border-bottom: 2px solid ${({ theme }) => theme.colors.white};
  border-right: 2px solid ${({ theme }) => theme.colors.white};
`;

export const SizeLabel = styled.label`
  font-size: 16px;
  line-height: 120%;
`;
